module.exports = __webpack_public_path__ + "img/solution-6.e9f0760f.jpg";